/** In milliseconds */
const milliseconds = 20000;

export default milliseconds;
